import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKadoFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 223.82 223.82",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "a",
		gradientUnits: "userSpaceOnUse",
		x2: 223.82,
		y1: 111.91,
		y2: 111.91,
		children: [
			/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				stopColor: "#fcc997"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#d55566"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#6b98b2"
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		d: "m186.08 0h-148.33a37.86 37.86 0 0 0 -37.75 37.75v148.33a37.86 37.86 0 0 0 37.75 37.74h148.33a37.85 37.85 0 0 0 37.74-37.74v-148.33a37.86 37.86 0 0 0 -37.74-37.75zm-144.91 34.91h33.13a6.63 6.63 0 1 1 0 13.26h-33.13a6.63 6.63 0 0 1 0-13.26zm0 35.19h28.83a46.62 46.62 0 0 0 33.62-14.42l17.81-18.68a6.63 6.63 0 0 1 9.57 9.11l-17.8 18.71a60 60 0 0 1 -43.2 18.54h-28.83a6.63 6.63 0 0 1 0-13.26zm33.13 118.81h-33.13a6.63 6.63 0 0 1 0-13.26h33.13a6.63 6.63 0 1 1 0 13.26zm56.51-1.82a6.65 6.65 0 0 1 -9.38-.24l-17.8-18.71a46.61 46.61 0 0 0 -33.63-14.41h-28.83a6.63 6.63 0 0 1 0-13.26h28.83a59.94 59.94 0 0 1 43.24 18.53l17.76 18.71a6.64 6.64 0 0 1 -.19 9.38zm1-64.33 54.83 54.83a6.63 6.63 0 1 1 -9.37 9.38l-54.84-54.84a46.11 46.11 0 0 0 -32.81-13.59h-48.45a6.63 6.63 0 0 1 0-13.26h48.41a46.07 46.07 0 0 0 32.81-13.59l54.84-54.84a6.63 6.63 0 0 1 9.37 9.38l-54.83 54.84a59.92 59.92 0 0 1 -14.83 10.84 60.21 60.21 0 0 1 14.83 10.85z",
		fill: "url(#a)"
	})]
});
export default SvgKadoFill;
